export default {
    "GENERAL": {
        "TOGGGLE_NAVIGATION": "Navigáció",
        "OK": "Ok",
        "CANCEL": "Mégse",
        "YES": "Igen",
        "NO": "Nem",
        "BACK": "Vissza",
        "SAVE": "Mentés",
        "SAVING": "Mentés ...",
        "SAVED": "Mentve",
        "ADD": "Hozzáad",
        "REMOVE": "Eltávolít",
        "DELETE_MODEL": "Biztos törlöd: {model} ?",
        "DELETE": "Törlés",
        "DELETING": "Törlés ...",
        "DELETED": "Törölve",
        "DONE": "Kész",
        "EDIT": "Szerkeszt",
        "SEND": "Küldés",
        "SENT": "Elküldve",
        "SUCCESS": "Siker",
        "ERROR": "Hiba",
        "NOTFOUND": "404 - Nem található",
        "CREATED_AT": "Létrehozva",
        "UPDATED_AT": "Módosítva",
        "IMAGE": "Kép",
        "IMAGES": "Képek",
        "IMPORT": "Importálás",
        "FILTER": "Szűrés",
        "LOADING": "Töltés ...",
        "AND": "És",
        "OR": "Vagy",
        "FIELD": "Mező",
        "VALUE": "Érték",
        "OPERATOR": "Operátor",
        "CONDITION": "Feltétel",
        "RELATION": "Kapcsolat",
        "EQUAL": "Egyenlő",
        "NOT_EQUAL": "Nem egyenlő",
        "NEW": "Új",
        "ON_SITE": "Látható az oldalon",
        "YEAR": "Év",
        "FILE": "Fájl",
        "ON_MOBILE": "Látható mobilon",
        "ON_MAP": "Látható a térképen",
        "LEFT": "Bal",
        "RIGHT": "Jobb",
        "UPLOAD": "Feltöltés",
        "LINK": "Link",
        "TITLE": "Cím",
        "DATE": "Dátum",
        "TEXT": "Szöveg",
        "VIDEO": "Videó",
        "VIDEO_ID": "Videó ID",
        "NEXT_PAGE": "&gt;",
        "LAST_PAGE": "&gt;&gt;",
        "PREVIOUS_PAGE": "&lt;",
        "FIRST_PAGE": "&lt;&lt;",
        "RECOMMENDATIONS": "Ajnáló",
        "SEARCH": "Keresés",
        "PROGRAM": "Program",
        "TOP": "Top program",
        "ROUTE": "Útvonal",
        "ROUTES": "Útvonalak",
        "TRAVEL_TIME": "Idő (s)",
        "UID": "Azonosító",
        "BATTERY": "Akkumulátor",
        "LAST_DATA_DATE": "Utolsó adat",
        "START": "Indulás",
        "RETURN": "Visszaút",
        "COLOR": "Szín",
        "PUBLISHING": "Közzétesz..",
        "PUBLISHED": "Közzétéve",
        "UNPUBLISHING": "Visszavon..",
        "UNPUBLISHED": "Visszavonva",
        "COVER_IMAGE": "Borítókép",
        "GALLERY_YEAR": "Év",
        "GALLERY_DAY": "Nap",
        "HIDDEN": "Rejtett",
        "NAME": "Név",
        "POSITION": "Pozíció",
        "EMAIL": "Email",
        "PHONE": "Telefon",
        "DESCRIPTION": "Leírás",
        "GROUP": "Csoport",
        "DISABLED": "Letiltva",
        "ENABLED": "Engedélyezve",
        "EXPORT": "Exportálás",
    }
}



// WEBPACK FOOTER //
// ./src/i18n/messages/hu/general.js